<script setup lang="ts">
/** Statement by Auditors (Section 261) — M32016 */
import EpcDocVarField from './EpcDocVarField.vue';
</script>

<template>
  <div class="epc-doc">
    <div class="doc-head">
      <div class="doc-company"><EpcDocVarField field-key="company_name" /></div>
      <div class="doc-meta">Company Registration No: <EpcDocVarField field-key="company_registration_no" /></div>
      <div class="doc-meta italic">(Incorporated in Malaysia)</div>
    </div>

    <div class="dcr-title">STATEMENT BY AUDITORS PURSUANT TO SECTION 261, COMPANIES ACT, 2016</div>

    <p class="doc-p">
      In pursuance of Section 261 of the Companies Act, 2016 the accounts made up to
      <EpcDocVarField field-key="fs_made_up_to" />
      which have been circulated to the members of the company to which this statement relates to,
    </p>
    <p class="doc-p indent">(i) have been audited in accordance with the said Act; and</p>
    <p class="doc-p indent">(ii) have not been qualified and no comments were made in pursuance of Section 266(3) of the Companies Act, 2016;</p>
    <p class="doc-p">and in our opinion the company,</p>
    <p class="doc-p indent">(i) has kept proper accounting records and other books during the period covered by those accounts; and</p>
    <p class="doc-p indent">(ii) as at the date to which the income statement has been made up appeared to have been able to meet its liabilities as and when they fall due.</p>

    <p class="doc-p" style="margin-top:16px"><b>Dated :</b> <EpcDocVarField field-key="statement_date" /></p>

    <div class="sig-block" style="margin-top:28px">
      <div class="sig-line long">________________________________________________________________</div>
      <div class="doc-p"><EpcDocVarField field-key="auditor_name" /></div>
      <div class="doc-p"><b>Audit License No :</b> <EpcDocVarField field-key="audit_license_no" /></div>
      <div class="doc-p" style="font-weight:700; letter-spacing:.02em">CHARTERED ACCOUNTANT</div>
    </div>

    <div class="sig-block" style="margin-top:28px">
      <div class="sig-line long">________________________________________________________________</div>
      <div class="doc-p"><EpcDocVarField field-key="audit_firm_name" /></div>
      <div class="doc-p"><b>Audit Firm No.:</b> <EpcDocVarField field-key="audit_firm_number" /></div>
      <div class="doc-p" style="font-weight:700; letter-spacing:.02em">CHARTERED ACCOUNTANTS, MALAYSIA</div>
    </div>

    <p class="doc-lbl-title" style="margin-top:28px">LODGER INFORMATION</p>
    <table class="cdd-tbl epc-lodger">
      <colgroup>
        <col style="width:32%" />
        <col style="width:68%" />
      </colgroup>
      <tbody>
        <tr>
          <td class="cdd-lcell">Name</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_name" placeholder="Name" /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">NRIC No</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_nric" placeholder="NRIC No." /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Address</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_address" placeholder="Address" /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Phone No</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_phone" placeholder="Phone No." /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Email</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_email" placeholder="Email" /></div></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style src="./epcDoc.css"></style>
<style scoped>
.epc-lodger .cell-field :deep(.epcf) {
  display: flex !important;
  width: 100%;
  max-width: 100%;
}
.epc-lodger .cell-field :deep(.epcf-in) {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
